@if (newsFeedPosition == 'above-subnav') {
    <cc-nav-news-feed
        [isLobbyLoaded]="isLobbyLoaded()"
        [extendMenuDslEvalCompleted]="extendMenuDslEvalCompleted()"
        [lobbyType]="lobbyType"
        [categoryRoute]="categoryRoute" />
}

<nav
    id="casino-nav"
    class="casino-nav"
    *ngIf="enableSubNav"
    [style.padding]="enablePillsSubNavigation && !isTouch ? '0 1.5rem !important' : '0 .75rem 0 0'"
    [ngClass]="{
        'sbopen': smartBannerOpened,
        'sbclose': !smartBannerOpened || !smartBannersExists,
        'enabled-desktop-icons': subNavConfigEnableDesktopIcon,
        'pills-subnav': enablePillsSubNavigation,
        'top-nav-newstyling': enableTopNavStyling,
    }">
    @if (isLobbyLoaded() && extendMenuDslEvalCompleted()) {
        <!-- Mobile Navigation -->
        <div class="category-container casino-mobile-navigation" *ngIf="shouldShowMobileSubNavigation()">
            <div class="resizable-container">
                <div id="fixedtabdevmobile" class="fixed-tab-div navigation-main" style="float: left">
                    <ul class="fixed-tabs">
                        <li
                            class="fixed-tabs-li nav-li"
                            *ngIf="showSearchInTopNavigation"
                            [ngClass]="{ 'brave-nav-width': enableSubNavigationBgColor }"
                            (click)="showSearch()">
                            <a>
                                <div class="icon theme-search-i"></div>
                                <div class="sub-navigation-name">
                                    <div class="name">{{ searchText }}</div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="fixed-tabs-li nav-li"
                            *ngIf="showHomeFixedNavigation"
                            [ngClass]="{ 'brave-nav-width': enableSubNavigationBgColor }"
                            (click)="goToDefaultPage('showHomeFixedNavigation')">
                            <a [href]="mcPageDefaultHomePageUrl">
                                <div class="icon theme-badge"></div>
                                <div class="sub-navigation-name">
                                    <div class="name">{{ defaultPageText }}</div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="item home fixed-tabs-li nav-li"
                            *ngIf="fixednavEnabled && showHomeInTopNavigation"
                            [ngClass]="{ 'brave-nav-width': enableSubNavigationBgColor }"
                            (click)="goToDefaultPage('fixednavEnabled')">
                            <a [href]="mcPageDefaultHomePageUrl">
                                <div class="icon theme-badge"></div>
                                <div class="sub-navigation-name">
                                    <div class="name">{{ defaultPageText }}</div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="item home fixed-tabs-li nav-li"
                            *ngIf="isPromotionPagesEnabled"
                            [ngClass]="{ 'brave-nav-width': enableSubNavigationBgColor }"
                            (click)="goToPromotionPage()">
                            <a>
                                <div class="icon theme-badge"></div>
                                <div class="sub-navigation-name">
                                    <div class="name">{{ promotionLinkText }}</div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- display mobile navigation bar -->
                <div #mobilenavItems>
                    <ul
                        *ngIf="defaultCategoryType || ForceMobileNav"
                        [ngClass]="{ fixedMobileNav: enableFixedMobileNavigation }"
                        (scroll)="thumbnailScroll()">
                        <ng-container *ngIf="extendTopMenuState && !extendedTopMenuToRight">
                            <li
                                id="{{ menu.name }}"
                                class="nav-li"
                                *ngFor="let menu of extendTopMenu | dsl | async"
                                [ngClass]="{ 'active': currentUrl == menu.url, 'brave-nav-width': enableSubNavigationBgColor }"
                                [ngStyle]="
                                    enableSubNavigationBgColor ? { 'background-color': menu.iconBackgroundColor, 'color': menu.iconTextColor } : {}
                                "
                                (click)="goToUrl(menu.url)">
                                <a *ngIf="menu.pathname" [routerLink]="[menu.pathname]" (click)="setActiveMobile(menu.name)">
                                    <div
                                        class="icon"
                                        [ngClass]="menu.cssClass"
                                        [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}"></div>
                                    <div class="name" [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}">
                                        {{ menu.title }}
                                    </div>
                                </a>
                                <a href="{{ menu.url }}" *ngIf="!menu.pathname" (click)="setActiveMobile(menu.name)">
                                    <div
                                        class="icon"
                                        [ngClass]="menu.cssClass"
                                        [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}"></div>
                                    <div class="name" [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}">
                                        {{ menu.title }}
                                    </div>
                                </a>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let category of navItems">
                            @defer {
                                <li
                                    id="{{ category.categoryid }}"
                                    class="{{ category.categoryid }}"
                                    class="nav-li"
                                    *ngIf="category.isNavigationCategory"
                                    [hidden]="defaultCategoryType && defaultCategoryType.categoryid === category.categoryid && hideHomeInSubNav"
                                    [ngClass]="{
                                        'active':
                                            categoryType === category.categoryid ||
                                            (currentUrl == category.url && (category.fromExtendedMenuRight || selectedUrl)),
                                        'casino-active-thumnail':
                                            category?.displayThumbnail &&
                                            displayThumbnailMobile &&
                                            (isDefaultCategory || categorySelected?.displayThumbnail),
                                        'from-extended-menu-right': category.fromExtendedMenuRight,
                                        'brave-nav-width': enableSubNavigationBgColor,
                                    }"
                                    [ngStyle]="
                                        enableSubNavigationBgColor
                                            ? {
                                                  'background-color': category?.sitecoreData?.attributes?.iconbackgroundcolor,
                                                  'color': category?.sitecoreData?.attributes?.icontextcolor,
                                              }
                                            : {}
                                    ">
                                    <a
                                        *ngIf="!category.isExtendedTopMenuItem && category.pathname"
                                        [routerLink]="[category.pathname]"
                                        (click)="setActiveMobile(category.categoryid); categoryTracking($event, category.index, category.categoryid)">
                                        <span *ngIf="category.isNavigationCategory">
                                            <div
                                                class="icon"
                                                [ngClass]="category.sitecoreData.attributes.icon"
                                                [ngStyle]="
                                                    enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                                ">
                                                <span
                                                    class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge"
                                                    *ngIf="category.signPostingCount > 0 && isSignPosting"
                                                    >{{ category.signPostingCount > 99 ? 99 : category.signPostingCount }}</span
                                                >
                                                <span
                                                    class="badge badge-square badge-offset badge-t-r badge-danger casino-navigation-badge discover-badge"
                                                    *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeText"
                                                    [ngStyle]="{ color: badgeColor, background: badgeTextColor }"
                                                    >{{ categoryStickerName }}</span
                                                >
                                                <span
                                                    class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge badge-icon {{
                                                        badgeIcon
                                                    }}"
                                                    *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeIcon"
                                                    [ngStyle]="{ color: badgeColor, background: badgeTextColor }"></span>
                                            </div>
                                            <div class="sub-navigation-name">
                                                <div
                                                    class="name"
                                                    [ngClass]="{ thumbnailActive: category.sitecoreData.gameThumbnail }"
                                                    [ngStyle]="
                                                        enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                                    ">
                                                    {{ category.categoryname }}
                                                </div>
                                            </div>
                                        </span>
                                    </a>
                                    <a
                                        href="{{ category.url }}"
                                        *ngIf="!category.isExtendedTopMenuItem && !category.pathname"
                                        (click)="setActiveMobile(category.categoryid); categoryTracking($event, category.index, category.categoryid)">
                                        <span *ngIf="category.isNavigationCategory">
                                            <div
                                                class="icon"
                                                [ngClass]="category.sitecoreData.attributes.icon"
                                                [ngStyle]="
                                                    enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                                ">
                                                <span
                                                    class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge"
                                                    *ngIf="category.signPostingCount > 0 && isSignPosting"
                                                    >{{ category.signPostingCount > 99 ? 99 : category.signPostingCount }}</span
                                                >
                                                <span
                                                    class="badge badge-square badge-offset badge-t-r badge-danger casino-navigation-badge discover-badge"
                                                    *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeText"
                                                    [ngStyle]="{ color: badgeColor, background: badgeTextColor }"
                                                    >{{ categoryStickerName }}</span
                                                >
                                                <span
                                                    class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge badge-icon {{
                                                        badgeIcon
                                                    }}"
                                                    *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeIcon"
                                                    [ngStyle]="{ color: badgeColor, background: badgeTextColor }"></span>
                                            </div>
                                            <div class="sub-navigation-name">
                                                <div
                                                    class="name"
                                                    [ngClass]="{ thumbnailActive: category.sitecoreData.gameThumbnail }"
                                                    [ngStyle]="
                                                        enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                                    ">
                                                    {{ category.categoryname }}
                                                </div>
                                            </div>
                                        </span>
                                    </a>
                                    <a
                                        *ngIf="category.isExtendedTopMenuItem && category.pathname"
                                        [routerLink]="[category.pathname]"
                                        (click)="extentRightMenuTracking(category.url, category.categoryid)">
                                        <span class="{{ category.sitecoreData.categoryId }}">
                                            <div class="icon" [ngClass]="category.sitecoreData.attributes.icon"></div>
                                            <div class="sub-navigation-name">
                                                <div class="name" [innerHtml]="category.categoryname"></div>
                                            </div>
                                        </span>
                                    </a>
                                    <a
                                        href="{{ category.url }}"
                                        *ngIf="category.isExtendedTopMenuItem && !category.pathname"
                                        (click)="extentRightMenuTracking(category.url, category.categoryid)">
                                        <span class="{{ category.sitecoreData.categoryId }}">
                                            <div class="icon" [ngClass]="category.sitecoreData.attributes.icon"></div>
                                            <div class="sub-navigation-name">
                                                <div class="name" [innerHtml]="category.categoryname"></div>
                                            </div>
                                        </span>
                                    </a>
                                </li>
                            }
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
        <!-- epcot sub nav -->
        @if (enablePillsSubNavigation) {
            <cc-pill-sub-navigation
                #pillSubNav
                [config]="{
                    isTouch,
                    showSearchInTopNavigation,
                    showHomeFixedNavigation,
                    fixednavEnabled,
                    showHomeInTopNavigation,
                    isPromotionPagesEnabled,
                    searchText,
                    mcPageDefaultHomePageUrl,
                    promotionLinkText,
                    extendedTopMenuToRight,
                    enableFixedMobileNavigation,
                    currentUrl,
                    categoryType,
                    displayThumbnailMobile,
                    isDefaultCategory,
                    isSignPosting,
                    discoverFeedLmtkey,
                    displayDiscoverSticker,
                    isBadgeTypeText,
                    categoryStickerName,
                    badgeIcon,
                    ForceMobileNav,
                    isBadgeTypeIcon,
                    hideHomeInSubNav,
                    enableVnIconsForPills,
                }"
                [defaultPageText]="defaultPageText"
                [extendTopMenuState]="extendTopMenuState"
                [myNavCategories]="myNavCategories"
                [navItems]="navItems"
                [categorySelected]="categorySelected"
                [defaultCategoryType]="defaultCategoryType"
                [extendTopMenu]="extendTopMenu"
                (goToPromotionPage)="goToPromotionPage()"
                (goToUrl)="goToUrl($event)"
                (setActiveMobile)="setActiveMobile($event)"
                (categoryTracking)="categoryTracking($event.event, $event.index, $event.categoryid)"
                (extentRightMenuTracking)="extentRightMenuTracking($event.url, $event.categoryid)"
                (thumbnailScroll)="thumbnailScroll()"
                (showSearch)="showSearch()"
                (goToDefaultPage)="goToDefaultPage($event)"></cc-pill-sub-navigation>
        }

        <!-- Desktop Navigation -->
        <div class="category-container casino-desktop-navigation" *ngIf="shouldShowDesktopSubNavigation()">
            <div class="resizable-container">
                <div
                    #fixedtabdev
                    id="fixedtabdev"
                    class="fixed-tab-div navigation-main"
                    style="float: left"
                    *ngIf="
                        showHomeFixedNavigation ||
                        (fixednavEnabled && showHomeInTopNavigation) ||
                        isPromotionPagesEnabled ||
                        (extendTopMenuState && !extendedTopMenuToRight)
                    ">
                    <ul class="deskNav-ul fixed-tabs">
                        <li
                            class="nav-li"
                            *ngIf="showHomeFixedNavigation"
                            [ngClass]="{ 'brave-nav-width': enableSubNavigationBgColor }"
                            (click)="goToDefaultPage('showHomeFixedNavigation')">
                            <a [href]="mcPageDefaultHomePageUrl">
                                <span class="icon theme-badge" *ngIf="subNavConfigEnableDesktopIcon"></span>
                                <div class="name">{{ defaultPageText }}</div>
                            </a>
                        </li>
                        <li
                            class="nav-li item home"
                            *ngIf="fixednavEnabled && showHomeInTopNavigation"
                            [ngClass]="{ 'brave-nav-width': enableSubNavigationBgColor }"
                            (click)="goToDefaultPage('fixednavEnabled')">
                            <a [href]="mcPageDefaultHomePageUrl">
                                <span class="icon theme-badge" *ngIf="subNavConfigEnableDesktopIcon"></span>
                                <div class="name">{{ defaultPageText }}</div>
                            </a>
                        </li>
                        <li
                            class="nav-li item home"
                            *ngIf="isPromotionPagesEnabled"
                            [ngClass]="{ 'brave-nav-width': enableSubNavigationBgColor }"
                            (click)="goToPromotionPage()">
                            <a>
                                <span class="icon theme-badge" *ngIf="subNavConfigEnableDesktopIcon"></span>
                                <div class="name">{{ promotionLinkText }}</div>
                            </a>
                        </li>
                        <ng-container *ngIf="extendTopMenuState && !extendedTopMenuToRight">
                            <li
                                id="{{ menu.name }}"
                                class="nav-li item"
                                *ngFor="let menu of extendTopMenu | dsl | async"
                                [ngClass]="{ 'active': currentUrl == menu.url, 'brave-nav-width': enableSubNavigationBgColor }"
                                [ngStyle]="
                                    enableSubNavigationBgColor ? { 'background-color': menu.iconBackgroundColor, 'color': menu.iconTextColor } : {}
                                "
                                (click)="goToUrl(menu.url)">
                                <a *ngIf="menu.pathname" [routerLink]="[menu.pathname]">
                                    <div
                                        class="icon"
                                        [ngClass]="menu.cssClass"
                                        [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}"></div>
                                    <div class="name" [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}">
                                        {{ menu.title }}
                                    </div>
                                </a>
                                <a href="{{ menu.url }}" *ngIf="!menu.pathname">
                                    <div
                                        class="icon"
                                        [ngClass]="menu.cssClass"
                                        [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}"></div>
                                    <div class="name" [ngStyle]="enableSubNavigationBgColor ? { color: menu.iconTextColor } : {}">
                                        {{ menu.title }}
                                    </div>
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div #deskNav id="deskNav" style="float: left" class="navigation-main" [ngClass]="moreclassVariable">
                    <ul class="deskNav-ul">
                        <ng-container>
                            <li
                                id="{{ category.categoryid }}"
                                class="nav-li"
                                *ngFor="let category of myNavCategories; let i = index"
                                [hidden]="!category.isNavigationCategory"
                                [ngClass]="{
                                    'casino-active-thumbnail-desktop': category?.displayThumbnail && displayThumbnailDesktop,
                                    'from-extended-menu-right': category.fromExtendedMenuRight,
                                    'active': categoryType === category.categoryid || (currentUrl == category.url && category.fromExtendedMenuRight),
                                    'brave-nav-width': enableSubNavigationBgColor,
                                }"
                                [ngStyle]="
                                    enableSubNavigationBgColor
                                        ? {
                                              'background-color': category?.sitecoreData?.attributes?.iconbackgroundcolor,
                                              'color': category?.sitecoreData?.attributes?.icontextcolor,
                                          }
                                        : {}
                                "
                                (mouseenter)="moreHover(true)">
                                <span
                                    class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge"
                                    *ngIf="category.signPostingCount > 0 && isSignPosting"
                                    >{{ category.signPostingCount > 99 ? 99 : category.signPostingCount }}</span
                                >
                                <span
                                    class="badge badge-square badge-offset badge-t-r badge-danger casino-navigation-badge discover-badge"
                                    *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeText"
                                    [ngStyle]="{ color: badgeColor, background: badgeTextColor }"
                                    >{{ categoryStickerName }}</span
                                >
                                <span
                                    class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge badge-icon {{ badgeIcon }}"
                                    *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeIcon"
                                    [ngStyle]="{ color: badgeColor, background: badgeTextColor }"></span>
                                <a
                                    *ngIf="category && category.pathname && category.sitecoreData && !category.isExtendedTopMenuItem"
                                    [routerLink]="[category.pathname]"
                                    (click)="categoryTracking($event, category.index, category.sitecoreData.categoryId)">
                                    <span>
                                        <span
                                            class="icon"
                                            *ngIf="subNavConfigEnableDesktopIcon"
                                            [ngClass]="category.sitecoreData.attributes.icon"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            "></span>
                                        <div
                                            class="name"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            ">
                                            {{ category.categoryname }}
                                        </div>
                                    </span>
                                </a>
                                <a
                                    href="{{ category.url }}"
                                    *ngIf="category && !category.pathname && category.sitecoreData && !category.isExtendedTopMenuItem"
                                    (click)="categoryTracking($event, category.index, category.sitecoreData.categoryId)">
                                    <span>
                                        <span
                                            class="icon"
                                            *ngIf="subNavConfigEnableDesktopIcon"
                                            [ngClass]="category.sitecoreData.attributes.icon"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            "></span>
                                        <div
                                            class="name"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            ">
                                            {{ category.categoryname }}
                                        </div>
                                    </span>
                                </a>
                                <a
                                    *ngIf="category.isExtendedTopMenuItem && category.pathname"
                                    [routerLink]="[category.pathname]"
                                    (click)="extentRightMenuTracking(category.url, category.categoryid)">
                                    <span>
                                        <span
                                            class="icon"
                                            *ngIf="subNavConfigEnableDesktopIcon"
                                            [ngClass]="category.sitecoreData.attributes.icon"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            "></span>
                                        <div
                                            class="name"
                                            [innerHtml]="category.categoryname"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            "></div>
                                    </span>
                                </a>
                                <a
                                    href="{{ category.url }}"
                                    *ngIf="category.isExtendedTopMenuItem && !category.pathname"
                                    (click)="extentRightMenuTracking(category.url, category.categoryid)">
                                    <span>
                                        <span
                                            class="icon"
                                            *ngIf="subNavConfigEnableDesktopIcon"
                                            [ngClass]="category.sitecoreData.attributes.icon"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            "></span>
                                        <div
                                            class="name"
                                            [innerHtml]="category.categoryname"
                                            [ngStyle]="
                                                enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}
                                            "></div>
                                    </span>
                                </a>
                                <div class="thumbnail-newgame" *ngIf="category?.displayThumbnail && displayThumbnailDesktop">
                                    <div class="casino-thumbnail-arrow-down" [ngStyle]="thumbnailArrowColor(category)"></div>
                                    <cc-thumbnail-newgame
                                        [category]="category"
                                        [place]="'Sub Navigation'"
                                        [lobbyType]="lobbyType"
                                        [isTouch]="isTouch"
                                        (closeThumbnail)="closeThumbnailBox($event)"></cc-thumbnail-newgame>
                                </div>
                            </li>

                            <li
                                id="moregameslist"
                                class="moregameslist"
                                class="nav-li"
                                *ngIf="moreCategories.length > 0"
                                [ngClass]="{
                                    'active-more': isMoreActive,
                                    'more-border-remove': hideMore,
                                    'subnav-more-shadow brave-nav-width': enableSubNavigationBgColor,
                                }"
                                (mouseenter)="moreHover(false)"
                                (click)="moreClick($event)"
                                (mouseleave)="moreMouseLeave()">
                                <a>
                                    <span class="icon more-desktop-icon" *ngIf="subNavConfigEnableDesktopIcon" [ngClass]="moreIcon"></span>
                                    <cc-global-translate [key]="'More'"></cc-global-translate>
                                </a>
                            </li>
                        </ng-container>
                        <ng-container *ngIf="moreCategories">
                            <div id="{{ categoryMores.categoryid }}" *ngFor="let categoryMores of moreCategories">
                                <div class="casino-thumbnail-newgame-more" *ngIf="categoryMores?.displayThumbnail && displayThumbnailDesktop">
                                    <div class="casino-thumbnail-arrow-down" [ngStyle]="thumbnailArrowColor(categoryMores)"></div>
                                    <cc-thumbnail-newgame
                                        [category]="categoryMores"
                                        [lobbyType]="lobbyType"
                                        [isTouch]="isTouch"
                                        [place]="'Sub Navigation'"
                                        (closeThumbnail)="closeThumbnailBox($event)"></cc-thumbnail-newgame>
                                    <!-- <h1>Thumbnail</h1> -->
                                </div>
                            </div>
                        </ng-container>
                    </ul>
                    <ul
                        id="more-select"
                        class="more-select"
                        [hidden]="hideMore || !(moreCategories.length > 0)"
                        (mouseleave)="moreHover(true)"
                        (mouseenter)="overlayMouseEnter()">
                        <li
                            id="{{ category.categoryid }}"
                            *ngFor="let category of moreCategories; let i = index"
                            [value]="i"
                            [ngClass]="{ 'active': currentUrl == category.url, 'brave-nav-width': enableSubNavigationBgColor }"
                            [ngStyle]="
                                enableSubNavigationBgColor
                                    ? {
                                          'background-color': category?.sitecoreData?.attributes?.iconbackgroundcolor,
                                          'color': category?.sitecoreData?.attributes?.icontextcolor,
                                      }
                                    : {}
                            ">
                            <a
                                *ngIf="!category.isExtendedTopMenuItem && category.pathname"
                                [routerLink]="[category.pathname]"
                                [ngStyle]="enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}"
                                (click)="categoryTracking($event, category.index, category.categoryid, true)">
                                <div>
                                    {{ category.categoryname }}
                                    <span
                                        class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge"
                                        *ngIf="category.signPostingCount > 0 && isSignPosting"
                                        >{{ category.signPostingCount > 99 ? 99 : category.signPostingCount }}</span
                                    >
                                    <span
                                        class="badge badge-square badge-offset badge-t-r badge-danger casino-navigation-badge discover-badge"
                                        *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeText"
                                        [ngStyle]="{ color: badgeColor, background: badgeTextColor }"
                                        >{{ categoryStickerName }}</span
                                    >
                                    <span
                                        class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge badge-icon {{
                                            badgeIcon
                                        }}"
                                        *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeIcon"
                                        [ngStyle]="{ color: badgeColor, background: badgeTextColor }"></span>
                                </div>
                            </a>
                            <a
                                href="{{ category.url }}"
                                *ngIf="!category.isExtendedTopMenuItem && !category.pathname"
                                [ngStyle]="enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}"
                                (click)="categoryTracking($event, category.index, category.categoryid, true)">
                                <div>
                                    {{ category.categoryname }}
                                    <span
                                        class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge"
                                        *ngIf="category.signPostingCount > 0 && isSignPosting"
                                        >{{ category.signPostingCount > 99 ? 99 : category.signPostingCount }}</span
                                    >
                                    <span
                                        class="badge badge-square badge-offset badge-t-r badge-danger casino-navigation-badge discover-badge"
                                        *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeText"
                                        [ngStyle]="{ color: badgeColor, background: badgeTextColor }"
                                        >{{ categoryStickerName }}</span
                                    >
                                    <span
                                        class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge badge-icon {{
                                            badgeIcon
                                        }}"
                                        *ngIf="discoverFeedLmtkey == category.categoryid && displayDiscoverSticker && isBadgeTypeIcon"
                                        [ngStyle]="{ color: badgeColor, background: badgeTextColor }"></span>
                                </div>
                            </a>
                            <a
                                *ngIf="category.isExtendedTopMenuItem && category.pathname"
                                [routerLink]="[category.pathname]"
                                [ngStyle]="enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}"
                                (click)="categoryTracking($event, category.index, category.categoryid, true)">
                                <div>
                                    {{ category.categoryname }}
                                </div>
                            </a>
                            <a
                                href="{{ category.url }}"
                                *ngIf="category.isExtendedTopMenuItem && !category.pathname"
                                [ngStyle]="enableSubNavigationBgColor ? { color: category?.sitecoreData?.attributes?.icontextcolor } : {}"
                                (click)="categoryTracking($event, category.index, category.categoryid, true)">
                                <div>
                                    {{ category.categoryname }}
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                @if (innerWidth >= 768 || !isTouch) {
                    <div #cssearchcomponent id="compartmentalise" class="cssearchcomponent">
                        <cc-lazy-search-desktop
                            [isTouch]="isTouch"
                            [placeholder]="'navigation'"
                            [lobbyType]="lobbyType"
                            [categoryRoute]="categoryRoute" />
                    </div>
                }
            </div>
        </div>
    }
</nav>
@if (newsFeedPosition == 'below-subnav') {
    <cc-nav-news-feed
        [isLobbyLoaded]="isLobbyLoaded()"
        [extendMenuDslEvalCompleted]="extendMenuDslEvalCompleted()"
        [lobbyType]="lobbyType"
        [categoryRoute]="categoryRoute" />
}
@if (isLobbyLoaded() && extendMenuDslEvalCompleted()) {
    <div *ngIf="navItems">
        <div class="casino-mobile-thumbnail-wrapper" *ngFor="let categoryMobileItem of navItems">
            <div *ngIf="categoryMobileItem?.displayThumbnail && displayThumbnailMobile && (isDefaultCategory || categorySelected?.displayThumbnail)">
                <div class="casino-thumbnail-mobile" [class.thumbnailAnimate]="thumbnailVisible">
                    <div class="casino-thumbnail-arrow-down-mobile" *ngIf="displayThumbnailMobile" [style.left.px]="arrowPosition"></div>
                    <cc-thumbnail-newgame
                        [category]="categoryMobileItem"
                        [place]="'Sub Navigation'"
                        [lobbyType]="lobbyType"
                        [isTouch]="isTouch"
                        (closeThumbnail)="closeThumbnailBox($event)"></cc-thumbnail-newgame>
                </div>
            </div>
        </div>
    </div>
}
<router-outlet></router-outlet>
